<!-- src/components/InviteCode/InviteCode.vue -->
<template>
  <section>
    <ValidationObserver ref="obs" >
      <div class="ct-loading" v-if="loadingCode"></div>
      
      <section class="setter">
        <div class="img-left">
          <p></p>
           <v-img cover src="https://s3.amazonaws.com/assets.pilsala.com/assets/asian_woman.jpg"></v-img>
        </div>
        
        <div class="div-rigth">
          <section class="section-rigth">
            <div>
              <v-img cover :src="dynamicImageUrl" class="max-w-300"></v-img>
            </div>
            
            <section class="d-flex flex-column min-w-250">
              <p>
                Has recibido un código de acceso <strong>{{ inviteCode }}</strong> para esta experiencia de aprendizaje.<br>
              </p>

              <p class="p-text">
                Completa los datos para registrar tu cuenta
              </p>

              <section class="d-flex flex-column">
                <div class="d-flex-2">
                  <div class="w-50">
                    <p class="p13">¿Cuál es tu nombre?</p>
                    <ValidationProvider
                      name="nombre"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        outlined
                        label="Nombre"
                        v-model="name"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </div>
                  <div class="ml-5 w-50">
                    <p class="p13">¿Cuál es tu apellido?</p>
                    <ValidationProvider
                      name="apellido"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        outlined
                        full-width
                        label="Apellido"
                        v-model="last_name"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </div>
                </div>

                <div class="d-flex-2">
                  <div>
                    <p class="p13">País (Prefijo)</p>
                    <country-autocomplete @dialog:change="HandlerCountryResponse" />
                  </div>
                  <div class="ml-5 w-100">
                    <p class="p13">WhatsApp</p>
                    <ValidationProvider
                      name="telefono"
                      rules="required|numeric"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        v-model="phone_number"
                        class="mt-3 ml-auto"
                        outlined
                        label="WhatsApp"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </div>
                </div>

                <div class="mt--2">
                  <p class="p13">Crear contraseña</p>
                  <ValidationProvider
                    name="contraseña"
                    rules="required|min:6"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      outlined
                      label="Contraseña"
                      v-model="password"
                      type="password"
                      :error-messages="errors"
                    ></v-text-field>
                  </ValidationProvider>
                </div>

                <div class="d-flex center">
                  <v-checkbox
                    v-model="checkbox"
                    value="1"
                    type="checkbox"
                    required
                  ></v-checkbox>
                  <div class="conditionsAndTermins">
                    <span>
                      <span>Al continuar aceptas nuestros </span>
                      <a href="https://pilsa.io/terminos-y-condiciones" target="_blank" rel="noopener noreferrer"
                        >términos y condiciones </a
                      >
                      <span> y </span>
                      <a href="https://pilsa.io/politica-de-privacidad" target="_blank" rel="noopener noreferrer"
                        >políticas de privacidad</a
                      >
                    </span>
                    <span> </span>
                  </div>
                </div>

                <v-btn
                  :disabled="!isValid"
                  depressed
                  class="white--text font-light py-5 text-capitalize mt-10"
                  rounded
                  color="#101820"
                  :loading="loading"
                  @click="HandlerRegister"
                >
                  Continuar
                </v-btn>

                

                <v-btn
                  v-if="false"
                  color="#f5f5f5"
                  rounded
                  class="gray--text bg-white py-3 text-none mb-2"
                  @click="HandlerRedirectSocialAccount('google')"
                  >
                  <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/><path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/><path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/><path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/><path d="M1 1h22v22H1z" fill="none"/></svg>

                    <span class="ml-2"> Conecta tu cuenta de Google </span>
                </v-btn>

                <v-btn
                  v-if="false"
                  color="#f5f5f5"
                  rounded
                  class="gray--text bg-white py-3 text-none mb-4"
                  @click="HandlerRedirectSocialAccount('linkedin')"
                  >
                    <svg height="24" viewBox="0 0 72 72" width="24" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path d="M8,72 L64,72 C68.418278,72 72,68.418278 72,64 L72,8 C72,3.581722 68.418278,-8.11624501e-16 64,0 L8,0 C3.581722,8.11624501e-16 -5.41083001e-16,3.581722 0,8 L0,64 C5.41083001e-16,68.418278 3.581722,72 8,72 Z" fill="#007EBB"/><path d="M62,62 L51.315625,62 L51.315625,43.8021149 C51.315625,38.8127542 49.4197917,36.0245323 45.4707031,36.0245323 C41.1746094,36.0245323 38.9300781,38.9261103 38.9300781,43.8021149 L38.9300781,62 L28.6333333,62 L28.6333333,27.3333333 L38.9300781,27.3333333 L38.9300781,32.0029283 C38.9300781,32.0029283 42.0260417,26.2742151 49.3825521,26.2742151 C56.7356771,26.2742151 62,30.7644705 62,40.051212 L62,62 Z M16.349349,22.7940133 C12.8420573,22.7940133 10,19.9296567 10,16.3970067 C10,12.8643566 12.8420573,10 16.349349,10 C19.8566406,10 22.6970052,12.8643566 22.6970052,16.3970067 C22.6970052,19.9296567 19.8566406,22.7940133 16.349349,22.7940133 Z M11.0325521,62 L21.769401,62 L21.769401,27.3333333 L11.0325521,27.3333333 L11.0325521,62 Z" fill="#FFF"/></g></svg>
                    <span class="ml-2"> Continuar con LinkedIn </span>
                </v-btn>
             

            </section>
          </section>
           </section>

        
        </div>
        
      </section>
    </ValidationObserver>
  </section>
</template>

<script>
import CountryAutocomplete from "@/components/Utils/country_autocomplete";

export default {
  components: {
    "country-autocomplete": CountryAutocomplete,
  },
  data() {
    return {
      loadingCode: false,
      loading: false,
      dynamicImageUrl: null,
      subdomain: "",
      name: "",
      last_name: "",
      country_id: {},
      phone_number: "",
      password: "",
      checkbox: null,
    };
  },
  computed: {
    scheduleId() {
      return this.$route.params.schedule_id;
    },
    inviteCode() {
      return this.$route.params.code;
    },
    isValid() {
      return this.name && this.last_name && this.country_id.id && this.phone_number && this.password && this.checkbox;
    }
  },
  created() {
    // Si scheduleId es 270, redirigir a la URL específica al cargar la vista
    if (parseInt(this.scheduleId) === 270) {
      window.location.href = `https://cimedumx.pilsa.io/invite/274/${this.inviteCode}`;
      return;
    }
    
    const subdomain = window.location.hostname.split('.')[0];
    this.subdomain =  subdomain && subdomain !== 'localhost' ? subdomain : 'app';
    this.dynamicImageUrl = `https://s3.amazonaws.com/assets.pilsala.com/brand_logos/${this.subdomain}.png`;
  },
  methods: {
    HandlerRedirectSocialAccount(provider) {
       window.location.href = `https://campus.pilsa.io/auth/${provider}/redirect?schedule_id=${this.scheduleId}&invite_code=${this.inviteCode}`;
    },
    HandlerCountryResponse(val) {
      this.country_id = val;
    },
    HandlerShowConditions() {
      window.location = "https://pilsa.io/terminos-y-condiciones";
    },

    HandlerShowPrivacyPolicy() {
      window.location = "https://pilsa.io/politica-de-privacidad";
    },

    async HandlerRegister() {
      try {
        this.loading = true;
        const request = {
          name: this.name,
          last_name: this.last_name,
          password: this.password,
          schedule_id: parseInt(this.scheduleId),
          invite_code: this.inviteCode,
          country_id: this.country_id.id,
          phone_number: this.phone_number,
          subdomain: this.subdomain,
        };
        
        const response = await this.$store.dispatch("auth/SIGNUP_WITH_CODE", request);
        
        window.location.href = `${window.location.origin}/login?data_ref=${response.data.data.user.encrypted_id}`;
        
      } catch (error) {
        console.log(error.response.data);
        this.$snotify.error(error.response.data.message ?? "Error al registrar la cuenta", "¡Error!");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
@media (max-width: 1024px) {
  .img-left {
    display: none !important;
  }
  .setter {
    width: 100% !important;
  }
  .div-rigth {
    width: 100% !important;
    padding: 0 1rem !important;
  }
}

.w-100 {
  width: 100%;
}
.p-relative {
  color: #949494;
  font: normal normal 300 13px/20px Poppins;
  position: absolute;
  bottom: 0;
}

.div-copyright {
        background-color: #f8f8f8;
        text-align: center;
        padding: 10px;
        position: fixed;
        left: 0;
        bottom: 0;
        width: 100%;
        z-index: 1000;
}

.p13 {
  font-size: 13px;
}
.p15 {
  font: normal normal normal 15px/21px Poppins;
  font-size: 15px;
}
.mt--2 {
  margin-top: -10px;
}
.section-rigth {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.p-text {
    margin-top: 1rem;
    margin-bottom: 2rem;
    font-family: "Poppins", serif;
    font-size: 20px;
    font-weight: 600;
    display: flex;
    flex-direction: column;
    text-align: center;
}
.setter {
  margin: 0px;
  padding: 0px;
  display: flex;
  height: 100vh;
  justify-content: space-between;
}
.img-left {
  width: 50vw;
  display: flex;
}
.flex-column {
  display: flex;
  flex-direction: column;
}
.div-rigth {
  position: relative;
  width: 50vw;
  display: flex;
  align-items: center;
  flex-direction: column;
  overflow: auto;
  flex-wrap: wrap;
  padding: 0 6rem;
  padding-top: 1em;
}
.d-flex {
  display: flex;
}
.max-width {
  max-width: 250px;
}

.subtitle_recover_password {
  text-align: center;
  font-family: "Poppins";
  font: normal normal 300 13px/20px Poppins;
  letter-spacing: 0px;
  color: #6f7b87;
  margin-bottom: 4rem !important;
}
.title_recover_password {
  font-family: "Poppins", serif;
  font-size: 28px;
  font-weight: 600;
  display: flex;
  flex-direction: column;
  text-align: center;
}

.recoverPasswordContainer_putCode2 {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.classBtnReqCode {
  color: white;
  border-radius: 32px;
  text-align: center;
  text-transform: capitalize;
  font-family: "Poppins";
  font: normal normal normal 15px/30px Poppins;
  letter-spacing: 0px;
  color: #101820;
}
.classConYouReq_text {
  text-align: center;
  font-family: "Poppins";
  font: normal normal 300 13px/20px Poppins;
  letter-spacing: 0px;
  color: #0076ff;
}
.recoverPasswordContainer_putCode {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

strong {

  font-weight: 600;
  color: #101820;

}
.closeWrelative {
  position: absolute;
  top: 0;
  margin: 3rem;
  right: 0;
}
.classContainerBtn {
  margin-bottom: 10rem;
}
.recoverPasswordContainer {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.subtitle_recover_password {
  text-align: center;
  font-family: "Poppins";
  font: normal normal 300 13px/20px Poppins;
  letter-spacing: 0px;
  color: #6f7b87;
  margin-bottom: 0rem !important;
}
.title_recover_password {
  font-family: "Poppins", serif;
  font-size: 28px;
  font-weight: 600;
  display: flex;
  flex-direction: column;
  text-align: center;
}
.custom-color {
  color: #929292;
}

.ct-loading{
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 999;
  background: #ffffff91;
}

.w-50 {
  width: 50%;
}
.conditionsAndTermins {
  text-align: left;
  font: normal normal 300 13px/20px Poppins;
}
.center {
  align-items: center;
  justify-content: center;
}
.d-flex-2 {
  display: flex;
  justify-content: space-between;
}

</style>